<template>
  <a
    v-if="isButtonShown"
    :href="feedbackLink"
    class="feedback-btn"
    target="_blank"
    @click="hideButton"
  >
    Feedback
  </a>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SideFeedbackButton",
  data() {
    return {
      isButtonShown: true
    };
  },
  computed: {
    ...mapState(["navigationTags"]),
    feedbackLink() {
      return this.navigationTags?.topOfPage?.links?.feedback?.url;
    }
  },
  methods: {
    hideButton() {
      this.isButtonShown = false;
    }
  }
};
</script>

<style lang="less">
.feedback-btn {
  font-family: "PlusJakartaSansRegular";
  font-size: 1.8rem;
  width: 151px;
  background-color: #0d2835;
  color: #fff;
  border: none;
  position: fixed;
  z-index: 100;
  right: -62px;
  top: 380px;
  transform: translateY(-50%) rotate(-90deg);
  text-align: center;
  padding: 2px;

  &:hover {
    color: #fff;
  }

  &:focus {
    background-color: #0F152E;
  }
}
</style>
